import { useState, useEffect } from "react";
import LoginPage from "./LoginPage";
import ProfilePage from "./ProfileComps/ProfilePage";
import { useAppContext } from "../AppContext";

export default function Profile() {
  const { User, setUser } = useAppContext();
  const [isLoggedIn, setIsLoggedIn] = useState(() => !!localStorage.getItem("user"));

  // Restore context user from localStorage after a page refresh
  useEffect(() => {
    if (isLoggedIn && !User) {
      try {
        setUser(JSON.parse(localStorage.getItem("user")));
      } catch {
        localStorage.removeItem("user");
        setIsLoggedIn(false);
      }
    }
  }, []);

  const handleLoginSuccess = () => setIsLoggedIn(true);

  return isLoggedIn ? (
    <ProfilePage />
  ) : (
    <LoginPage onLoginSuccess={handleLoginSuccess} />
  );
}
